import { NgModule } from '@angular/core';
import { CapslockDetectorDirective } from './capslock-detector.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [TooltipModule.forRoot()],
  declarations: [CapslockDetectorDirective],
  exports: [CapslockDetectorDirective]
})
export class CapslockDetectorModule {}
